import React from "react";

import styles from "./echodottop.module.css";

export function EchoDotTop(props) {
  const { className, style } = props;
  return <div className={`${styles.echodot} ${className}`} style={style} />;
}
